import React, { Component } from 'react';
import Device from "./Device";

class DeviceCollection extends Component {

    render() {
        const devices = this.props.devices.map( (device) => (
                <Device
                    {...this.props}
                    uuid={device.uuid}
                    key={device.uuid}
                />
            )
        );

        return(
            <div>
                {devices}
            </div>
        )
    }
}

export default DeviceCollection;
